
import React, { useState, useEffect, useRef } from 'react';
import { Card } from '../ui/card';
import { Input } from '../ui/input';
import { MapPin, AlertCircle, CheckCircle } from 'lucide-react';

export const VALID_CHICAGO_ZIP_CODES = [
  '60601', '60602', '60603', '60604', '60605', '60606',
  '60610', '60611', '60613', '60614', '60618', '60625', 
  '60630', '60634', '60637', '60640', '60641', '60642',
  '60645', '60647', '60654', '60657', '60659', '60660',
  '60661', '60706'
];

export default function ZipCodeValidator({ zipCode, validZip, onZipChange, onValidChange }) {
  const [showError, setShowError] = useState(false);
  const [shake, setShake] = useState(false);
  const inputRef = useRef(null);

  const triggerShake = () => {
    setShake(true);
    setTimeout(() => setShake(false), 600);
  };

  const handleZipChange = (value) => {
    const numericValue = value.replace(/\D/g, '').slice(0, 5);
    onZipChange(numericValue);

    if (numericValue.length === 5) {
      const isValid = VALID_CHICAGO_ZIP_CODES.includes(numericValue);
      onValidChange(isValid);
      setShowError(!isValid);

      if (!isValid) {
        triggerShake();
      }

      if (inputRef.current) {
        inputRef.current.blur();
      }
    } else {
      onValidChange(false);
      setShowError(false);
    }
  };

  useEffect(() => {
    triggerShake();
  }, []);

  useEffect(() => {
    if (zipCode?.length === 5) {
      setShowError(!validZip);
    } else {
      setShowError(false);
    }
  }, [zipCode, validZip]);

  const inputStatusClass = showError ? 'zip-input-error' : validZip ? 'zip-input-success' : '';

  return (
    <Card className={`zip-shell ${shake ? 'zip-shake' : ''}`}>
      <div className="zip-icon">
        <MapPin style={{ height: 32, width: 32, color: 'var(--slate-600)' }} />
      </div>

      <div>
        <h3 className="zip-title">Where do we clean?</h3>
        <p className="zip-subcopy">Enter your Chicago ZIP code to confirm we serve your neighborhood.</p>
      </div>

      <div className="zip-input-wrap">
        <Input
          ref={inputRef}
          value={zipCode}
          onChange={(e) => handleZipChange(e.target.value)}
          className={`zip-input ${inputStatusClass}`}
          placeholder="60601"
          maxLength={5}
          inputMode="numeric"
          pattern="[0-9]*"
        />

        {zipCode.length === 5 && (
          <div className={`zip-indicator ${validZip ? 'zip-indicator-success' : 'zip-indicator-error'}`}>
            {validZip ? <CheckCircle size={18} /> : <AlertCircle size={18} />}
          </div>
        )}
      </div>

      {zipCode.length === 5 && (
        <div className={`zip-banner ${validZip ? 'zip-banner-success' : 'zip-banner-error'}`}>
          {validZip ? <CheckCircle size={18} /> : <AlertCircle size={18} />}
          <span>
            {validZip
              ? "Great news! You're in our service area. Scroll down to customize your clean."
              : "We're not in this ZIP just yet, but feel free to explore the Fresh Shine experience below."}
          </span>
        </div>
      )}
    </Card>
  );
}
